<div class="target-view">
  @if (showIncentiveData) {
    <div class="bottom">
      <coin-v2-card
        padding="extra-large"
        rounding="extra-large"
        shadow="large"
        [header]="'season-mgmt.incentive.monitoring.records.individual-multiplier' | translate">
        <div class="plan">
          <p class="bold">Plan name: {{ record?.plan?.title }}</p>
          <coin-v2-button
            type="secondary"
            icon="chevron_right"
            iconPos="right"
            [text]="'season-mgmt.incentive.monitoring.records.details.go-to-plan' | translate"
            (click)="goToPlan()"></coin-v2-button>
        </div>
      </coin-v2-card>
    </div>
  }

  @if (showIncentiveData) {
    <div class="bottom">
      <coin-v2-card
        styleVariant="large"
        [header]="'season-mgmt.incentive.monitoring.records.achievement-data' | translate">
        <div class="group">
          <div>
            <p>{{ getTranslatedKey('durationInCalenderDays') }}</p>
            <input
              matInput
              readonly
              [value]="$safeNavigationMigration(record?.durationInCalenderDays)" />
          </div>
          <div>
            <p>{{ getTranslatedKey('proration') }}</p>
            <input
              matInput
              readonly
              [value]="$safeNavigationMigration(record?.proration) | percent: '1.2-2' : 'de-DE'" />
          </div>
          <div>
            <p>{{ getTranslatedKey('proratedTargetIncentiveAmount') }}</p>
            <input
              matInput
              readonly
              appTwoDecimalPlaces
              [value]="$safeNavigationMigration(record?.proratedTiaLocalCurrency)" />
          </div>
          <div>
            <p>{{ getTranslatedKey('endAutoUpdate') }}</p>
            <input
              matInput
              readonly
              [value]="record?.state === recordState.Outdated ? 'true' : 'false'" />
          </div>
          @if (showIncentiveData) {
            <div>
              <p>{{ getTranslatedKey('payoutState') }}</p>
              <div>
                <input
                  matInput
                  readonly
                  [value]="displayRecordFieldFn($safeNavigationMigration(record?.payoutState))" />
                @if (editable()) {
                  <i
                    class="edit-button material-icons payout-state-edit"
                    (click)="editPayoutState()">
                    edit
                  </i>
                }
              </div>
            </div>
            @if (record?.payoutState === seasonRecordPayoutStateEnum.DefinedPayoutEndOfFiscalYear) {
              <div>
                <p>{{ getTranslatedKey('definedPayoutPercentage') }}</p>
                <input
                  matInput
                  readonly
                  coinAppTwoDecimalPlaces
                  [value]="$safeNavigationMigration(record?.definedPayoutPercentage)" />
              </div>
            }
            @if (isIncentiveAchievements()) {
              <div [class.edit-field]="editable()">
                <p>{{ getTranslatedKey('payoutDate') }}</p>
                <input
                  matInput
                  readonly
                  [value]="checkDate($safeNavigationMigration(record?.payoutDate)) | date: 'MM/yyyy'" />
                @if (editable()) {
                  <i
                    class="edit-button material-icons"
                    (click)="editPayoutDate()">
                    edit
                  </i>
                }
              </div>
            }
          }
        </div>
      </coin-v2-card>

      @if (showIncentiveData) {
        <coin-v2-card
          styleVariant="large"
          padding="none"
          [header]="'season-mgmt.incentive.monitoring.records.comments' | translate">
          <coin-siemens-energy-comments
            [comments]="recordComments"
            [embedded]="true"
            [additionalId]="$safeNavigationMigration(record?.id)"
            [commentType]="commentType.SeasonRecord"
            [user]="user$ | async"
            [commentService]="seasonRecordsCommentsService"></coin-siemens-energy-comments>
        </coin-v2-card>
      }

      @if (showIncentiveData) {
        <coin-v2-card
          class="achievement-table"
          styleVariant="large"
          [header]="'season-mgmt.incentive.monitoring.records.achievement-table' | translate">
          <div class="group">
            @if (recordAchievementTable) {
              <div class="achievement-table">
                <coin-incentive-record-achievement-table
                  [tableData]="recordAchievementTable"
                  [currency]="$safeNavigationMigration(record?.initialSnapshot?.localCurrencyIsoCode)"></coin-incentive-record-achievement-table>
              </div>
            } @else {
              <h4>No Achievements yet</h4>
            }
          </div>
        </coin-v2-card>
      }
    </div>
  }
</div>
